const workflowIconUnitOffset = 25
const workflowIconBaseOffset = 16

export const workflowIconOffsets = {
  RECONCILED: workflowIconBaseOffset,
  NOTES: workflowIconBaseOffset + workflowIconUnitOffset,
  TODOS: workflowIconBaseOffset + workflowIconUnitOffset * 2 + 2,
  CHECKS: workflowIconBaseOffset + workflowIconUnitOffset * 3,
  PROPOSAL: workflowIconBaseOffset + workflowIconUnitOffset * 4,
}

export const workflowProgressIconSelector = 'workflow-progress-icon'

// selects rows which are RTs or Accounts, but not Groups
export const TEMPLATE_ROW_SELECTOR =
  '[data-behaviour="account-list-item"].account'
export const DATA_FOR_FILTERING_ATTRIBUTE = '[data-for-filtering]'

export const collapsedGroupsStorageKey = (
  workflowId: number | string,
  reportId: number | string
): string => `wf.${workflowId}.${reportId}`
